import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
const linkEMSDevice = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.modifyDevice),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      deviceDetails: {
        deviceId: data.deviceId.toString(),
        entityId: data.mid.toString(),
        actionType: 'LINK',
      },
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { linkEMSDevice }
